import { ElMessageBox, ElNotification } from "element-plus";
import store from "../../store";
import apiAjax from "../../api";
//import { $zCommon } from "./zCommon"; //ajax组件

/**
 * 消息弹窗
 * @param msg      内容
 * @param title    标题
 * @param type      类型 主要通知:primary  成功通知:success  危险通知:danger  警告通知:warning
 * @param options  其他额外参数（参照对应ui文档）
 */
const $alertShow = function (msg, title, fun, options) {
  const defaultOptions = {
    confirmButtonText: "确定",
    dangerouslyUseHTMLString: true,
    callback: (action) => {
      if (fun) {
        fun(action);
      }
    },
  };
  const actualOptions = Object.assign({}, defaultOptions, options);
  ElMessageBox.alert(msg, title || "温馨提示", actualOptions);
};
const $notifyMsg = function (title, msg, type, options) {
  const defaultOptions = {
    title: title || "温馨提示",
    message: msg,
  };
  if (!!type) {
    defaultOptions.type = type;
  } else {
    defaultOptions.type = "success";
  }
  const actualOptions = Object.assign({}, defaultOptions, options);
  ElNotification(actualOptions);
};
/**
 * 确认提示框
 * @param msg         标题
 * @param title       内容
 * @param type       类型
 * @param confirm       确认回调
 * @param cancel        取消回调
 */
const $confirmMsg = function (
  msg,
  title,
  type,
  confirm,
  cancel,
  confirmtext,
  canceltext
) {
  ElMessageBox.confirm(msg, title, {
    confirmButtonText: confirmtext || "确定",
    cancelButtonText: canceltext || "取消",
    type: type || "warning",
  })
    .then(() => {
      if (confirm) {
        confirm();
      }
    })
    .catch(() => {
      if (cancel) {
        cancel();
      }
    });
};
//显示loading
const $loadingShow = function () {
  store.commit("setDataByName", { key: "fullscreenLoading", val: true });
};
//隐藏loading
const $loadingHide = function () {
  store.commit("setDataByName", { key: "fullscreenLoading", val: false });
};
/**
 * 全局post方法
 * 方式一：$post(url, postObj, isShowLoding, channel)
 * @returns {Promise<unknown>}
 * 方式二：$post(url, postObj, success, failure, isShowLoding, channel)
 * @returns null
 *
 * @param url      请求地址
 * @param postObj  请求参数
 * @param success  成功回调
 * @param failure  失败回调
 * @param isShowLoding  是否loading
 * @param channel  请求地址渠道
 */
const $Post = function () {
  let url, postObj, success, failure, isShowLoding, channel;
  url = arguments[0];
  postObj = arguments[1];
  //3号/4号 参数是函数，则视为方式二
  if (typeof arguments[2] == "function" || typeof arguments[3] == "function") {
    success = arguments[2];
    failure = arguments[3];
    isShowLoding = arguments[4];
    channel = arguments[5];
  } else {
    isShowLoding = arguments[2];
    channel = arguments[3];
  }
  if (isShowLoding) {
    $loadingShow("加载中");
  }
  //let userData = $zCommon.checklocalStorage("userdata");
  let headerObj = {};
  //if (!!userData) {
  //  if (!!userData.token) {
  //    headerObj.Authorization = "Bearer " + userData.token;
  //  } else {
  //    headerObj.Authorization = "";
  //  }
  //}
  return new Promise((resolve, reject) => {
    apiAjax.post(
      url,
      postObj,
      function (msg) {
        if (isShowLoding) {
          $loadingHide();
        }

        if (success) {
          success(msg);
        } else {
          resolve(msg);
        }
      },
      function (err) {
        if (isShowLoding) {
          $loadingHide();
        }

        if (failure) {
          failure(err);
        } else {
          reject(err);
        }
      },
      headerObj,
      channel
    );
  });
};

const $promiseAll = function (promiseList, success, fail) {
  Promise.all(promiseList.map((p) => p.catch((e) => e)))
    .then((res) => {
      if (success) {
        success(res);
      }
    })
    .catch((error) => {
      //console.log("error=>", error);
      if (fail) {
        fail(error);
      }
    });
};

const zGlobalFun = {
  $alertShow,
  $notifyMsg,
  $confirmMsg,
  $loadingShow,
  $loadingHide,
  $Post,
  $promiseAll,
};

//const zGlobal = {
//  install(Vue) {
//    Vue.provide("$zGlobal", zGlobalFun);
//  },
//  zGlobal: zGlobalFun,
//};
export default zGlobalFun;
export const $zGlobal = zGlobalFun;
